import { Component } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { AppErrorState } from 'src/app/core/services/error/error.constants';
import { ErrorService } from '../../core/services/error/error.service';
import { AppRoute } from '../../routing/routing.config';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
  AppErrorState = AppErrorState;
  errorState: AppErrorState = AppErrorState.UNKNOWN_ERROR;
  publicErrorCode: string;
  supportEmailHref: string;
  referrerUrl: AppRoute;

  constructor(
    private logger: NGXLogger,
    private errorService: ErrorService,
  ) {
    const extras = this.errorService.sharedNavigationExtras;

    this.logger.debug('[ErrorComponent]: extras ', extras);

    if (extras?.state?.errorState) {
      this.errorState = extras.state.errorState;
    }
    if (extras?.state?.publicErrorCode) {
      this.publicErrorCode = extras.state.publicErrorCode;
    }

    this.supportEmailHref = this.errorService.supportEmailHref(
      this.publicErrorCode
    );

    this.referrerUrl = this.errorService.sharedNavigationUrl;
    this.logger.debug('[ErrorComponent]: referrerUrl - ', this.referrerUrl);
  }
}
